<script setup>
import { computed, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Loading from '../../../../components/Loading.vue'
import { KkInfo } from '../../../../components/ui'
import Box from '../../../../components/Box'
import {
  KkIcon,
  KkCheckbox,
} from '../../../../components/base'
import { KkFilterModal } from '../../../../components/projects'
import { KkStoreSelectModal } from '../../../../components/domains/mapionBiz'
import {addAttributes} from '../../../../modules/filterModalConst'
import Select from '../../../../components/Select'
import cloneDeep from 'lodash.clonedeep'
const store = useStore()
const searchGroup = computed(() => store.state.companiesMapionBizSearchGroups.data)
const searchGroupLoading = computed(() => store.state.companiesMapionBizSearchGroups.loading)
const stores = computed(() => store.state.companiesLocationStores.data)
const meta = computed(() => store.state.companiesLocationStores.meta)
const storesLoading = computed(() => store.state.companiesLocationStores.loading)
const updateLoading = computed(() => store.state.companiesMapionBizSearchGroupsConditionStores.loading)
const formValues = computed(() => store.state.companiesSearchTagGroups.formValues)
const searchAttributes = computed(() => store.state.companiesSearchTagGroups.data)
const searchAttributesLoading = computed(() => store.state.companiesSearchTagGroups.loading)
const filteredStores  = computed(() => store.state.companiesLocationStores.filteredStores)
const readMapionBizSearchGroup = (searchGroupId) => store.dispatch('companiesMapionBizSearchGroups/readMapionBizSearchGroup', searchGroupId)
const readStores = (params) => store.dispatch('companiesLocationStores/readStores', { companyUuid: company_uuid, params: params })
const readStoresForFilter = (params) => store.dispatch('companiesLocationStores/readStoresForFilter', { companyUuid: company_uuid, params: params })
const readSearchTagGroups = () => store.dispatch('companiesSearchTagGroups/readSearchTagGroups')
const updateMapionBizSearchGroupConditionStores = (payload) => store.dispatch('companiesMapionBizSearchGroupsConditionStores/updateMapionBizSearchGroupConditionStores', { searchGroupId: search_group_id, payload: payload })
const setFormValues = (payload) => store.dispatch('companiesSearchTagGroups/setFormValues', payload)
const loading = computed(() => searchGroupLoading.value || searchAttributesLoading.value || storesLoading.value || updateLoading.value)

const { company_uuid, search_group_id } = useRoute().params
const state = reactive({
  filterModal: false,
  filterItems: [],
  selectStores: [],
  selectType: null,
  conditions: [],
  storeModal: false,
  modalStoreCondition: null,
  isFiltered: false,
  displayNumber: 50
})
const selectableStores = computed(() => {
  if(searchGroup.value.selectType === 'radio') {
    let selectedStoreUuids = []
    state.conditions.forEach(c => {
      const uuids = c.stores.map(s => s.uuid)
      selectedStoreUuids = selectedStoreUuids.concat(uuids)
    })
    return stores.value.filter(v => !selectedStoreUuids.includes(v.attributes.uuid))
  } else {
    return stores.value
  }
})

const selectableFilteredStores = computed(() => {
  if(searchGroup.value.selectType === 'radio') {
    let selectedStoreUuids = []
    state.conditions.forEach(c => {
      const uuids = c.stores.map(s => s.uuid)
      selectedStoreUuids = selectedStoreUuids.concat(uuids)
    })
    return filteredStores.value.filter(v => !selectedStoreUuids.includes(v.attributes.uuid))
  } else {
    return filteredStores.value
  }
})

const conditionOptions = () => {
  const results = {}
  searchGroup.value.conditions.forEach(v => {
    results[v.name] = v.id
  })
  return results
}
const createFilter = () => {
  const attributes = [
    searchAttributes.value.sites,
    searchAttributes.value.brands,
    searchAttributes.value.areas,
    searchAttributes.value.franchisees,
    searchAttributes.value.user_companies,
  ]
  if(searchAttributes.value.original_tag_group_a) attributes.push(searchAttributes.value.original_tag_group_a)
  if(searchAttributes.value.original_tag_group_b) attributes.push(searchAttributes.value.original_tag_group_b)
  if(searchAttributes.value.original_tag_group_c) attributes.push(searchAttributes.value.original_tag_group_c)
  if(searchAttributes.value.original_tag_group_d) attributes.push(searchAttributes.value.original_tag_group_d)
  if(searchAttributes.value.original_tag_group_e) attributes.push(searchAttributes.value.original_tag_group_e)
  attributes.push(searchAttributes.value.prefectures)
  state.filterItems = attributes.map((attr) => {
    if(attr && attr.kind){
      return addAttributes(attr, attr.kind)
    }
  })
}

const formInitialValues = {
  sites: [],
  brands: [],
  franchisees: [],
  areas: [],
  user_companies: [],
  prefectures: [],
  original_tag_group_a: [],
  original_tag_group_b: [],
  original_tag_group_c: [],
  original_tag_group_d: [],
  original_tag_group_e: [],
  connected_mapion_biz: [true],
}

const storesParams = () => {
  const { brands, areas, franchisees, user_companies, prefectures, sites } = formValues.value
  return {
    per: state.displayNumber,
    q:{
      name_cont: state.searchQuery || undefined,
      m: 'or',
    },
    search: {
      brand_ids: (brands && brands.length === 0) ? undefined : brands,
      area_ids: areas === 0 ? undefined : areas,
      franchisee_ids: franchisees === 0 ? undefined : franchisees,
      user_company_ids: user_companies === 0 ? undefined : user_companies,
      prefectures: prefectures === 0 ? undefined : prefectures,
      site_types: sites === 0 ? undefined : sites,
      original_tag_group_a_tag_ids: formValues.value.original_tag_group_a,
      original_tag_group_b_tag_ids: formValues.value.original_tag_group_b,
      original_tag_group_c_tag_ids: formValues.value.original_tag_group_c,
      original_tag_group_d_tag_ids: formValues.value.original_tag_group_d,
      original_tag_group_e_tag_ids: formValues.value.original_tag_group_e,
      connected_mapion_biz: [true],
    },
  }
}

const handleChangeFilterModalCheckBox = ({ kind, id }) => {
  const newFormValues = Object.assign({}, formValues.value)
  if(newFormValues[kind].includes(id)) {
    newFormValues[kind] = newFormValues[kind].filter((_id) => _id !== id)
  } else {
    newFormValues[kind].push(id)
  }
  setFormValues(newFormValues)
  readStoresForFilter(storesParams())
}


const search = (event) => {
  if (event.keyCode !== 13) return
  readStores(storesParams())
  state.isFiltered = true
}

const handleSubmitFilter = () => {
  readStores(storesParams())
  state.selectStores = []
  state.filterModal = false
  state.isFiltered = true
}

const handleReset = () => {
  setFormValues(formInitialValues)
  readStores({ search: formInitialValues })
  state.selectStores = []
  state.filterModal = false
  state.isFiltered = false
}

const handleReflectStores = () => {
  const condition = state.conditions.find(v => Number(v.id) === Number(state.selectType))
  const storeHash = {}
  stores.value.forEach(v => storeHash[v.attributes.uuid] = v.attributes.name)
  const selectedStores = state.selectStores.map(v => {
    return {
      uuid: v,
      name: storeHash[v]
    }
  })
  if(searchGroup.value.selectType === 'radio') {
    const newStores = condition.stores.concat(selectedStores)
    condition.stores = newStores
  } else {
    condition.stores = selectedStores
  }
  state.selectStores = []
}

const handleSubmit = () => {
  const params = {
    conditions: state.conditions.map(v => ({ id: v.id, store_uuids: v.stores.map(s => s.uuid) }))
  }
  updateMapionBizSearchGroupConditionStores(params)
}

const openStoreModal = (condition) => {
  state.modalStoreCondition = condition
  state.storeModal = true
}

const changeConditionStore = (storeUuids) => {
  const condition = state.conditions.find(v => Number(v.id) === state.modalStoreCondition.id)
  condition.stores = condition.stores.filter(v => !storeUuids.includes(v.uuid))
  state.storeModal = false
}

const checkStores = (uuid) => {
  if(state.selectStores.includes(uuid)) {
    state.selectStores = state.selectStores.filter(v => v !== uuid)
  } else {
    state.selectStores.push(uuid)
  }
}

const checkAllStores = () => {
  if(state.selectStores.length === selectableStores.value.length) {
    state.selectStores = []
  } else {
    state.selectStores = selectableStores.value.map(v => v.attributes.uuid)
  }
}

const selectConditionValidation =  computed(() => {
  return state.selectStores.length !== 0 && state.selectType
})


const load = async () => {
  await Promise.all([
    readMapionBizSearchGroup(search_group_id),
    readSearchTagGroups(),
    readStores({ search: formInitialValues })
  ])
  setFormValues(formInitialValues)
  createFilter()
  state.conditions = cloneDeep(searchGroup.value.conditions)
  if(meta.value.total_pages > 1) {
    state.displayNumber = meta.value.store_count
    readStores({ per: state.displayNumber, search: formInitialValues })
  }
}

load()
</script>

<template>
  <div>
    <div class="p-box">
      <Loading v-if="loading" />
      <template v-else>
        <div class="p-box__header">
          <div class="backToIndex">
            <router-link class="c-button__item c-button__item--outline" :to="{ name: 'CompaniesMapionBizSearchGroups', params: { company_uuid: company_uuid } }">
              {{ $t("pages.companies.mapionBizSearchGroupsForm.backToIndex") }}
            </router-link>
          </div>
        </div>
        <div class="p-box__body">
          <div class="c-grid">
            <div class="c-grid__items">
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__7 c-grid__item__l__7">
                <Box>
                  <template #header>
                    <span class="searchGroupName">{{ $t('pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.add.title', { title: searchGroup.name }) }}</span>
                  </template>
                  <template #body>
                    <div class="selectCondition">
                      <i18n-t keypath="pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.selectCondition">
                        <Select v-model="state.selectType" :options="conditionOptions()" class="selectCondition__content" />
                      </i18n-t>
                      <button
                        class="c-button__item c-button__item--primary"
                        :class="{'c-button__item--disabled': !selectConditionValidation}" :disabled="!selectConditionValidation"
                        @click="handleReflectStores"
                      >
                        {{ $t('labels.reflect') }}
                      </button>
                    </div>
                    <div class="filterContainer">
                      <div class="c-buttonFilter" @click="state.filterModal = !state.filterModal">
                        {{ $t('pages.CompaniesReviews.filters') }}
                        <div class="c-buttonFilter__icon">
                          <KkIcon name="iconFilter" />
                        </div>
                      </div>
                      <div class="c-searchField">
                        <input
                          v-model="state.searchQuery"
                          type="text"
                          class="searchForm"
                          :placeholder="$t('labels.locationSearch')"
                          @keydown.enter="search"
                        >
                        <div>
                          <KkIcon name="iconSearch" class="icon" />
                        </div>
                      </div>
                    </div>
                    <KkInfo v-if="searchGroup.selectType === 'radio'" icon="hint">
                      {{ $t('pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.status.radio.selectStoreInfo') }}
                    </KkInfo>
                    <div class="checkboxHeader">
                      <div class="allCheck">
                        <KkCheckbox
                          id="allCheck"
                          :model-value="state.selectStores.length === selectableStores.length && state.selectStores.length !== 0"
                          :label="$t('pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.allCheck')"
                          @change="checkAllStores"
                        />
                        (
                        <span v-if="searchGroup.selectType === 'checkbox' && !state.isFiltered">{{ $t('pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.status.checkbox.allStore') }}</span>
                        <span v-else>{{ $t(`pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.status.${ searchGroup.selectType }.selectableStore`, { count: selectableStores.length }) }}</span>
                        )
                      </div>
                      <div>
                        <i18n-t keypath="pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.storesCount" class="store-count-wap">
                          <span class="store-count">{{ state.selectStores.length }}</span>
                        </i18n-t>
                      </div>
                    </div>
                    <div v-for="(s, i) in selectableStores"
                         :key="'store' + i"
                         class="conditionContainer"
                    >
                      <KkCheckbox
                        :id="s.attributes.uuid"
                        :model-value="state.selectStores.includes(s.attributes.uuid)"
                        :label="s.attributes.name"
                        @change="checkStores(s.attributes.uuid)"
                      />
                    </div>
                  </template>
                </Box>
              </div>
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__5 c-grid__item__l__5">
                <Box>
                  <template #header>
                    {{ $t(`pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.status.${ searchGroup.selectType }.title`) }}
                  </template>
                  <template #body>
                    <KkInfo icon="hint">
                      {{ $t(`pages.companies.CompaniesMapionBizSearchGroupsStoreEdit.status.${ searchGroup.selectType }.info`) }}
                    </KkInfo>
                    <div v-for="(condition, i) in state.conditions"
                         :key="'condition' + i"
                         class="conditionContainer"
                    >
                      <div class="conditionContainer__wrap">
                        <div v-if="condition.icon" class="conditionContainer__image">
                          <img :src="condition.icon" alt="">
                        </div>
                        <div class="conditionContainer__contents">
                          <span v-if="condition.stores.length === 0">{{ $t('pages.companies.mapionBizSearchGroups.noStore', { name: condition.name }) }}</span>
                          <div v-else>
                            {{ condition.name }}
                            <button @click="openStoreModal(condition)">{{ $t('pages.companies.mapionBizSearchGroups.storeCount', { number: condition.stores.length }) }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="c-button">
                      <router-link
                        :to="{ name: 'CompaniesMapionBizSearchGroups', params: { company_uuid: company_uuid } }"
                        class="c-button__item c-button__item--outline-cancel"
                      >
                        {{ $t('labels.cancel') }}
                      </router-link>
                      <button
                        class="c-button__item c-button__item--primary"
                        @click="handleSubmit"
                      >
                        {{ $t('labels.save') }}
                      </button>
                    </div>
                  </template>
                </Box>
              </div>
            </div>
          </div>
        </div>
        <KkFilterModal
          :is-visible="state.filterModal"
          :filter-items="state.filterItems"
          :form-values="formValues"
          :total-count="selectableFilteredStores.length"
          @close="state.filterModal = false"
          @submit="handleSubmitFilter"
          @reset="handleReset"
          @change-check-box="handleChangeFilterModalCheckBox"
        />
        <KkStoreSelectModal
          v-if="state.storeModal"
          :is-visible="state.storeModal"
          :condition="state.modalStoreCondition"
          @close="state.storeModal = false"
          @submit="changeConditionStore"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../../../../stylesheets/biz_spa/foundation/_mixin.scss';
.backToIndex {
  margin-left: auto;
}
.conditionContainer {
  padding: 18px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  margin: 10px 0;
  &__wrap {
    display: flex;
  }
  &__name {
    font-weight: bold;
  }
  &__contents {
    font-size: 14px;
    display: flex;
    align-items: center;
    width: 70%;
    word-break: break-all;
  }
  &__image {
    margin-right: 10px;
    img {
      border: 1px solid #E4E7EB;
      border-radius: 4px;
      width: 60px;
      height: 60px;
    }
  }
}
.checkboxHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
}
.selectCondition {
  display: flex;
  align-items: center;
  padding: 18px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  margin-bottom: 15px;
  background: #E4E7EB;
  &__content {
    margin: 0 10px;
    width: 50%;
  }
}
.icon {
  width: 16px;
  height: 16px;
}
.filterContainer {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}
.c-buttonFilter {
  margin-right: 15px;
}

.store-count-wap {
  margin-right: 10px;
}
.store-count {
  margin: 0 5px;
  font-size: 30px;
  font-weight: 700;
  color: $color-accent-primary;
}
.allCheck {
  display: flex;
  align-items: center;
  font-weight: bold;
}
.c-button__item--disabled {
  border: none;
}
.searchGroupName {
  word-break: break-all;
}
</style>
